document.addEventListener('change', function(e){
  if(!e.target.matches('input[type="radio"][name^="purchase_type"]')) return;

  const radio = e.target;
  const wrapper = radio.closest('.eq_purchase_option');

  if(!wrapper) return;

  const selectedType = radio.value;

  const planInput = wrapper.querySelector('.selling_plan_input');
  const planSelect = wrapper.querySelector('.selling_plan_select');

 

  // SUBSCRIBE
  if(selectedType === 'subscribe'){
    document.body.classList.add('eq-subscribe-selected');
    document.body.classList.remove('eq-buyonce-selected');
    const subscriptionPrice = document.querySelector('.eq_purchase_price').getAttribute('data-subscription-price');
    if (subscriptionPrice) {
      document.querySelectorAll('.product-sticky-price').forEach((el) => {
        const bdi = el.querySelector('price-money bdi');
          if (bdi) {
                bdi.innerHTML = `<span class="price__prefix">$</span>${subscriptionPrice}<sup class="price__suffix">.00</sup>`;
          }
      });
    }
    if(planSelect){
      planSelect.disabled = false;
    }

    if(planInput && planSelect){
      planInput.value = planSelect.value || '';
      console.log('Set selling_plan_input to:', planInput.value);
    }

    const subscribeOption = document.querySelector('#purchage-option-subscribe');
    if (subscribeOption) {
      subscribeOption.click();
      subscribeOption.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // BUY ONCE
  if(selectedType === 'buy_once'){
    document.body.classList.add('eq-buyonce-selected');
    document.body.classList.remove('eq-subscribe-selected');
    const oneTimePrice = document.querySelector('.featured-one-time-price').getAttribute('data-one-time-price');
    if (oneTimePrice) {
    document.querySelectorAll('.product-sticky-price').forEach((el) => {
        const bdi = el.querySelector('price-money bdi');

        if (bdi) {
            bdi.innerHTML = `<span class="price__prefix">$</span>${oneTimePrice}<sup class="price__suffix">.00</sup>`;
        }
    });
}

    if(planInput){
      planInput.value = '';
    }

    if(planSelect){
      planSelect.disabled = true;
    }
    const oneTimeOption = document.querySelector('#purchage-option-one-time');
    if (oneTimeOption) {
      oneTimeOption.click();
      oneTimeOption.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
    const checkedRadio = document.querySelector('.purchase_radio:checked');

    if (checkedRadio) {
        checkedRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }
});